module.exports = __webpack_public_path__ + "media/application/images/projects/secondary_nav/minerals-8ab50475b32e5fbd83809b30978c3069.jpg";